import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import router from './router'
import store from './store'
import App from './App.vue'

import VueSocketIO from 'vue-3-socket.io'
import SocketIO from "socket.io-client"

// Global Varaibles

//
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

//
window.api = "http://127.0.0.1:3001"
window.api_socket = "http://127.0.0.1:3002"
if(window.location.href.includes(".com") ){
  window.api = "https://server.octowhats.com"
  window.api_socket = "https://websocket.octowhats.com"
}

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

import AudioRecorder from 'vue-audio-recorder'

Vue.use(AudioRecorder)

// Composition API
Vue.use(VueCompositionAPI)


import VuePlayer from '@iomariani/vue-player'

Vue.component('vue-player', VuePlayer)
import '@iomariani/vue-player/dist/vue-player.css'


// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

if(window.location.href.includes("autologin")){
  localStorage.setItem("user", JSON.stringify({jwt: window.location.href?.split("autologin/")[1]}))
  if(window.location.href.includes("?")){
    localStorage.setItem("user", JSON.stringify({jwt: window.location.href.split("?=")[1]}))
  }
  window.location = '/'
}

var user = {}

if(localStorage.getItem("user")){
  user = JSON.parse(localStorage.getItem('user'))
}

if(window.location.href.includes("/chat")){
  global.origin_id = window.location.hash.replace("#", "");
  Vue.use(new VueSocketIO({
    debug: false,
    connection: SocketIO(window.api_socket, {
        auth: {
          isMobile: screen.width <= 480,
          socket_id: user.socket_id,
          name: user.name,
          jwt: user.jwt,
          isAdmin: user.pers ? true : false,
          admin_id: user.admin_id,
          device_id: window.location.hash.replace("#", "")
        }
    })
  }))
}


window.alert = function(text, status='bg-secondary'){
  $("#open-alert").click()
  setTimeout(function(){
    $("#alert-msg").html(`<div class='alert text-white g text-center ${status == 100 ? 'bg-success' : (status == 200 ? 'bg-danger' : 'bg-secondary')}'>${text}</div>`)
  }, 100)
}

window.alert2 = function(text, status='bg-secondary'){
  $("#open-alert2").click()
  setTimeout(function(){
    $("#alert-msg2").html(`<div class='alert text-danger g text-center'>${text}</div>`)
    $("#alert-modal2___BV_modal_header_ > button").remove()
  }, 100)
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
